import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=3c6bb1de&scoped=true&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"
import style0 from "./Register.vue?vue&type=style&index=0&id=3c6bb1de&prod&lang=less&"
import style1 from "./Register.vue?vue&type=style&index=1&id=3c6bb1de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6bb1de",
  null
  
)

export default component.exports